/** Categories eligible for customer-facing AI resolution on voice call reports. */
export const AI_RESOLUTION_CATEGORIES = ["1", "2"];

/** LLM must return this exact token when no goal/FAQ fix is appropriate. */
export const NO_CONFIG_FIX_SENTINEL = "NO_CONFIG_FIX";

/**
 * Whether the report modal should show the AI-resolution action.
 * Voice-only; SMS and ineligible categories never qualify.
 */
export function isAiResolutionEligible(category, { isSms = false } = {}) {
  if (isSms) return false;
  return AI_RESOLUTION_CATEGORIES.includes(String(category));
}

export function isNoConfigFix(proposed) {
  if (proposed == null) return true;
  const trimmed = String(proposed).trim();
  if (!trimmed) return true;
  return trimmed === NO_CONFIG_FIX_SENTINEL;
}

/**
 * Build the savechatReportVoice payload extras for AI audit / apply.
 * Does not alter the base report fields — callers merge into the existing payload.
 *
 * BE contract (Chatlist::savechatReportVoice):
 * - ai_proposal          — original untouched LLM suggestion (always when present)
 * - ai_applied_config  — final edited text written to config (apply only)
 * - ai_applied           — 1 apply / 0 decline
 *
 * Prefer the explicit names originalProposal / appliedText at the call site so
 * the two values are never confused.
 */
export function buildAiResolutionReportExtras({
  originalProposal,
  appliedText,
  aiApplied,
  // Legacy aliases — prefer originalProposal / appliedText
  aiProposal,
  proposedConfig,
} = {}) {
  const proposal = (originalProposal != null ? originalProposal : aiProposal) || "";
  if (!proposal) return {};

  const extras = {
    ai_proposal: proposal,
    ai_applied: aiApplied ? 1 : 0,
  };

  if (aiApplied) {
    const applied = (appliedText != null ? appliedText : proposedConfig) || "";
    if (applied) {
      // Match BE storage column name so audit trail is unambiguous.
      extras.ai_applied_config = applied;
    }
  }

  return extras;
}
